import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class ValaszEditDto extends IdentifiableDto {
	constructor() {
		super();
		this.betujel = null;
        this.helyes = null;
        this.szoveg = null;
        this.magyarazat = null;
	}

	setup(props) {
		super.setup(props);
		this.betujel = props.betujel;
        this.helyes = props.helyes;
        this.szoveg = props.szoveg;
        this.magyarazat = props.magyarazat;
		return this;
	}
}

export default ValaszEditDto;
